import React from 'react'
import Highcharts from 'highcharts'

const primaryColor = '#5575C8'
const secondaryColor = '#5575C8'

export default class Chart extends React.Component {
  config = {
    chart: { type: 'area', spacing: [14, 0, 0, 0] },
    series: [
      {
        yAxis: 0,
        name: this.props.yLabel,
        data: this.props.data.map(val => val[this.props.yLabel]),
        pointStart: this.props.data[0][this.props.xLabel],
        showInLegend: false,
        animation: false,
        color: primaryColor,
        fillOpacity: 0.1,
      },
      {
        yAxis: 1,
        name: this.props.secondaryLabel,
        data: this.props.secondary.map(val => val[this.props.secondaryLabel]),
        pointStart: this.props.secondary[0][this.props.xLabel],
        showInLegend: false,
        animation: false,
        color: secondaryColor,
        fillOpacity: 0,
        dashStyle: 'shortdot',
      },
    ],
    xAxis: {
      allowDecimals: false,
      labels: {
        formatter() {
          return this.value
        },
      },
    },
    yAxis: [
      {
        opposite: true,
        gridLineDashStyle: 'dash',
        title: { text: this.props.yLabel, style: { color: primaryColor } },
        labels: {
          align: 'left',
          formatter() {
            return this.value === 0
              ? null
              : `${(this.value / 10000000).toFixed(0)}Cr`
          },
          style: { color: primaryColor },
        },
      },
      {
        gridLineDashStyle: 'dash',
        title: {
          text: this.props.secondaryLabel,
          style: { color: secondaryColor },
        },
        labels: {
          align: 'right',
          formatter() {
            return this.value === 0
              ? null
              : `${(this.value / 1000).toFixed(0)}K`
          },
          style: { color: secondaryColor },
        },
      },
    ],
    tooltip: {
      headerFormat: '',
      pointFormat: '{series.name} at age {point.x}: <b>{point.y}</b>',
      formatter: function() {
        if (this.series.name === 'Portfolio Value') {
          return `${this.series.name} at age ${this.x}: <b>${(
            this.y / 10000000
          ).toFixed(2)} Cr</b>`
        }
        if (this.series.name === 'Monthly Investment') {
          return `${this.series.name} at age ${this.x}: <b>${(
            this.y / 1000
          ).toFixed(2)} K</b>`
        }
      },
      borderRadius: 8,
    },
    plotOptions: {
      area: {
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
  }

  componentDidMount() {
    this.chart = Highcharts.chart(this.node, this.config)
  }

  componentWillReceiveProps(nextProps) {
    const vw = window.innerWidth
    if (vw < 420) {
      this.chart.setSize(vw - 16 * 3, null, false)
    } else if (this.props.editPanelOpen !== nextProps.editPanelOpen) {
      this.chart.setSize(
        this.props.editPanelOpen ? vw - 376 : vw - 710,
        null,
        false
      )
    }
    const nextData = nextProps.data.map(val => val[nextProps.yLabel])
    this.chart.series[0].setData(nextData)
    this.chart.series[0].update({
      data: nextData,
      pointStart: nextProps.data[0][nextProps.xLabel],
    })
    const nextSecondary = nextProps.secondary.map(
      val => val[nextProps.secondaryLabel]
    )
    this.chart.series[1].setData(nextSecondary)
    this.chart.series[1].update({
      data: nextSecondary,
      pointStart: nextProps.secondary[0][nextProps.xLabel],
    })
  }

  render() {
    const { editPanelOpen } = this.props
    return (
      <div
        className="chart"
        ref={node => (this.node = node)}
        style={{
          ...(window.innerWidth >= 420
            ? {
                minHeight: 'calc(650px - 372px - 49px)',
                height: 'calc(100vh - 372px - 49px)',
              }
            : { height: 300 }),
          width:
            window.innerWidth < 420
              ? window.innerWidth - 16 * 3
              : editPanelOpen
              ? 'calc(100vw - 710px)'
              : 'calc(100vw - 376px)',
          minWidth:
            window.innerWidth < 420
              ? window.innerWidth - 16 * 3
              : editPanelOpen
              ? 'calc(1200px - 710px)'
              : 'calc(1200px - 376px)',
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Chart.js